<template>
  <keep-alive exclude="share-publish">
    <router-view></router-view>
  </keep-alive>
</template>

<script>
export default {
  name: "share-index",
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style lang="less" scoped></style>
